import { render, staticRenderFns } from "./LegendPanelItem.vue?vue&type=template&id=77a19fc2&scoped=true&"
import script from "./LegendPanelItem.vue?vue&type=script&lang=js&"
export * from "./LegendPanelItem.vue?vue&type=script&lang=js&"
import style0 from "./LegendPanelItem.vue?vue&type=style&index=0&id=77a19fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a19fc2",
  null
  
)

export default component.exports